import React from 'react';
import { renderToString } from 'react-dom/server';

import { ApIcon, colors } from '@alixpartners/ui-components';
import { Wrapper } from './MenuCellRenderer.styles';

export const MenuCellRenderer = () => {
	return renderToString(
		<Wrapper className="contextual-menu">
			<ApIcon iconName="outline_more_vert" iconColor={colors.grey8} />
		</Wrapper>
	);
};
